import { render, staticRenderFns } from "./EditPageDynamic.vue?vue&type=template&id=6859c98c"
import script from "./EditPageDynamic.vue?vue&type=script&lang=js"
export * from "./EditPageDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports